export const RANGE = 'range';
export const DAILY = 'daily';
export const WEEKLY = 'weekly';
export const YEARLY = 'yearly';
export const MONTHLY = 'monthly';

export const TAG_TYPE_SEGMENTATION = 'segmentation';

export const RULE_MODIFIER = {
    and: 'and',
    or: 'or',
    orNot: 'orNot',
    andNot: 'andNot'
};

export const RULE_MODIFIER_MAP = {
    and: 'and',
    or: 'or',
    orNot: 'or',
    andNot: 'and'
};

export const USER_VISIBILITY = {
    all: 'all',
    guest: 'guest',
    user: 'user',
    noDeposit: 'noDeposit',
    depositOneTime: 'depositOneTime',
    depositTwoOrMore: 'depositTwoOrMore'
};
